import { IAccountIntegration } from "../../interfaces/memberInteriorSettings/iAccountIntegration";

export class AccountIntegration implements IAccountIntegration {
    id: number;
    type: string;
    lastName: string;
    firstName: string;
    profileUrl: string;

    constructor(accountIntegration: IAccountIntegration = {} as IAccountIntegration) {
        this.id = accountIntegration.id;
        this.type = accountIntegration.type;
        this.lastName = accountIntegration.lastName;
        this.firstName = accountIntegration.firstName;
        this.profileUrl = accountIntegration.profileUrl;

	}
}



// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/memberInteriorSettings/accountIntegration.ts